import { paths } from 'src/routes/paths';

import { getConfig } from './config';
import packageJson from '../package.json';

import type { Config } from './config';

const config = getConfig();

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  assetsDir: string;
  auth: {
    skip: boolean;
    redirectPath: string;
  };
  firebase: Config['firebaseConfig'];
  mapboxApiKey: string;
  algolia: Config['algolia'];
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: 'Matto Admin',
  appVersion: packageJson.version,
  serverUrl: '',
  assetsDir: '',

  auth: {
    skip: false,
    redirectPath: paths.dashboard.root,
  },

  mapboxApiKey:
    'pk.eyJ1IjoibWF0YW5hc3NhMDMiLCJhIjoiY201Y3JoajF3MXFlYjJrcTVsams1angzbCJ9.PerVt4UbYlTKASi2ryZ6uA',

  firebase: config.firebaseConfig,
  algolia: config.algolia,
};
